/* Homies size calculator. Ported from the retired from-scratch rebuild (main
   branch, assets/hm-size-calculator.js) onto the live Be-Yours theme 2026-08-17.
   Decision logic unchanged. CTA classes swapped from the old theme's btn/
   btn--ghost to Dawn/Be-Yours's button/button--secondary.

   Every threshold comes from the client's own published sizing page, read from
   the hm-size-logic data island. Nothing is inferred here.

   The two rules that resolve the gaps between sizes are the client's own:
     - exactly on a size's top end  -> size up
     - between two sizes            -> size up and add the 5 cm cushion

   Breed NEVER produces a final answer. The client states plainly that "breed
   alone is not enough", and that most returns happen because dogs were not
   measured, so a breed-only recommendation would increase returns. Breed only
   hints; the measurement decides.
*/
(function (global) {
  'use strict';

  // ---- decision tree -----------------------------------------------------
  // Exported so it can be unit-tested without a DOM.
  function recommend(backLengthCm, weightKg) {
    var len = parseFloat(backLengthCm);
    var kg = weightKg === '' || weightKg === null || weightKg === undefined ? NaN : parseFloat(weightKg);

    if (isNaN(len)) {
      return { status: 'need_measurement' };
    }
    // Weight is a hard ceiling regardless of length.
    if (!isNaN(kg) && kg > 20) {
      return { status: 'over_capacity' };
    }
    if (len < 30) {
      return { status: 'too_small' };
    }
    if (len >= 53) {
      // M is the largest size, so "size up" has nowhere to go.
      return { status: 'too_large' };
    }
    // Exactly on a size's top end -> size up.
    if (len === 35) { return { status: 'ok', size: 'S', cushion: false, reason: 'top_of_range' }; }
    if (len === 43) { return { status: 'ok', size: 'M', cushion: false, reason: 'top_of_range' }; }

    if (len < 35) { return { status: 'ok', size: 'XS', cushion: false, reason: 'in_range' }; }
    if (len < 40) { return { status: 'ok', size: 'S', cushion: true, reason: 'between_sizes' }; }
    if (len < 43) { return { status: 'ok', size: 'S', cushion: false, reason: 'in_range' }; }
    if (len < 51) { return { status: 'ok', size: 'M', cushion: true, reason: 'between_sizes' }; }
    return { status: 'ok', size: 'M', cushion: false, reason: 'in_range' };
  }

  global.HomiesSize = { recommend: recommend };

  // ---- UI ----------------------------------------------------------------
  if (typeof document === 'undefined') return;

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-size-calculator]');
    if (!root) return;

    var dataEl = document.querySelector('.hm-size-data');
    var data = null;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var breedSel = root.querySelector('[data-sc-breed]');
    var lenInput = root.querySelector('[data-sc-length]');
    var weightInput = root.querySelector('[data-sc-weight]');
    var goBtn = root.querySelector('[data-sc-go]');
    var out = root.querySelector('[data-sc-result]');
    var hint = root.querySelector('[data-sc-breed-hint]');
    if (!goBtn || !out) return;

    var variantMap = {};
    try { variantMap = JSON.parse(root.getAttribute('data-variant-map') || '{}'); } catch (e) {}

    // Breed selection only hints. It never fills the measurement for the
    // customer and never yields a recommendation on its own.
    if (breedSel && hint) {
      breedSel.addEventListener('change', function () {
        var size = breedSel.value;
        if (!size) { hint.hidden = true; return; }
        var entry = data.sizes.filter(function (s) { return s.code === size; })[0];
        hint.hidden = false;
        hint.textContent = entry
          ? (data.msg ? data.msg.hintPrefix : 'Dogs like this are usually a') + ' ' + entry.code + ' (' + (data.msg ? data.msg.hintBackLength : 'back length') + ' ' + entry.min + '-' + entry.max + ' cm). ' + data.breedWarning
          : data.breedWarning;
      });
    }

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text) n.textContent = text;
      return n;
    }

    function render(result) {
      out.textContent = '';
      out.hidden = false;

      var contact = function (msg) {
        out.appendChild(el('p', null, msg));
        var a = el('a', 'button button--secondary', (data.msg && data.msg.messageUs) || 'Message us before ordering');
        a.href = 'mailto:info@homiesdogwear.com';
        out.appendChild(a);
      };

      if (result.status === 'need_measurement') {
        out.appendChild(el('p', null, ((data.msg && data.msg.needMeasurement) || 'Add your dog’s back length to get a recommendation.') + ' ' + data.measureNote));
        return;
      }
      if (result.status === 'over_capacity') {
        contact((data.msg && data.msg.overCapacity) || ('Over ' + data.maxWeightKg + ' kg the dog carrier bag is not the right fit, whatever the back length.'));
        return;
      }
      if (result.status === 'too_small') {
        contact((data.msg && data.msg.tooSmall) || 'That is shorter than our smallest size (XS starts at 30 cm). Send us a message and we will help you check.');
        return;
      }
      if (result.status === 'too_large') {
        contact((data.msg && data.msg.tooLarge) || 'That is at or beyond the top of our largest size (M fits up to 53 cm). Send us a message before ordering and we will help you check.');
        return;
      }

      // Recommendation
      var head = el('p', 'hm-sc__result-head');
      head.appendChild(document.createTextNode(((data.msg && data.msg.recommended) || 'Recommended size:') + ' '));
      var strong = el('strong', null, result.size);
      head.appendChild(strong);
      out.appendChild(head);

      if (result.reason === 'top_of_range') {
        out.appendChild(el('p', null, (data.msg && data.msg.topOfRange) || 'Your dog measures exactly at the top of the smaller size, so we recommend sizing up for comfort.'));
      }
      if (result.reason === 'between_sizes') {
        out.appendChild(el('p', null, (data.msg && data.msg.betweenSizes) || 'Your dog falls between two sizes. We recommend the larger size plus the 5 cm cushion for a closer fit.'));
      }
      if (result.cushion) {
        out.appendChild(el('p', 'hm-sc__result-cushion', (data.msg && data.msg.addCushion) || 'Add the 5 cm cushion with your order.'));
      }

      var vid = variantMap[result.size];
      if (vid) {
        var cta = el('a', 'button', ((data.msg && data.msg.chooseVariant) || 'Choose SIZE').replace('SIZE', result.size));
        cta.href = (root.getAttribute('data-product-url') || '') + '?variant=' + vid;
        out.appendChild(cta);
      }
    }

    goBtn.addEventListener('click', function () {
      render(recommend(lenInput ? lenInput.value : '', weightInput ? weightInput.value : ''));
    });

    // Enter submits from either number field.
    [lenInput, weightInput].forEach(function (i) {
      if (!i) return;
      i.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); goBtn.click(); }
      });
    });
  });
})(typeof window !== 'undefined' ? window : globalThis);
